import { CommonModule, DecimalPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { isEmpty } from 'lodash';

@Component({
    selector: 'app-finance-product-card',
    standalone: true,
    imports: [CommonModule, TranslateModule, MatIconModule, DecimalPipe],
    templateUrl: './finance-product-card.component.html',
})
export class FinanceProductCardComponent {
    @Input() product: any;
    @Input() filter: any;
    @Input() selectedLanguage: string;
    @Input() isSelected: boolean = false;
    showMore: boolean = false;
    gaEventId: string = '';
    gaEventCategory: string = '';
    gaEventLable: string = '';
    monthlyRepayment: number | string = 0;

    constructor(private router: Router) {}

    ngOnInit() {
        if (this.product) {
            this.calculateRepayment();
            this.setupGaEvent();
        }
    }

    setupGaEvent() {
        if (this.product) {
            this.gaEventId = `${this.product.prodCode}_check_eligibility_button_financing_calculator_click`;
            this.gaEventCategory = 'Financing Calculator Button';
            this.gaEventLable = `Check Eligibility Button Click`;
        }
    }

    ngDoCheck() {
        if (this.product) {
            this.calculateRepayment();
        }
    }

    calculateRepayment() {
        if (this.filter && this.filter.amount !== 0) {
            let {
                amount: fAmount,
                duration: fDuration,
                interestRate: fInterest,
                durationUnit,
            } = this.filter;
            fAmount = Number(fAmount);
            const validation = JSON.parse(this.product.productValidation);
            const totalInterest =
                fAmount * (validation.interestRate.max / 100) * fDuration;
            this.monthlyRepayment = (
                (fAmount + totalInterest) /
                (durationUnit === 'years' ? fDuration * 12 : fDuration)
            ).toFixed(2);
        } else {
            const validation = JSON.parse(this.product.productValidation);
            if (validation?.financeAmount) {
                const totalInterest =
                    validation.financeAmount.min *
                    (validation.interestRate.max / 100) *
                    validation.tenure.max;
                this.monthlyRepayment = (
                    (validation.financeAmount.min + totalInterest) /
                    (validation.tenure.unit === 'years'
                        ? validation.tenure.max * 12
                        : validation.tenure.max)
                ).toFixed(2);
            }
        }
    }

    getImgUrl(img) {
        if (!isEmpty(img)) {
            return img;
        } else if (isEmpty(img)) {
            let url = '';
            if (this.selectedLanguage == 'bm') {
                url = '/assets/images/image_not_available_bm.webp';
            } else if (this.selectedLanguage == 'en') {
                url = '/assets/images/image_not_available_en.webp';
            }
            return url;
        }
    }

    toggleSelect() {
        this.isSelected = !this.isSelected;
    }

    toggleDesc() {
        this.showMore = !this.showMore;
    }

    checkEligibility() {
        this.router.navigate(['/business-financing'], {
            state: {
                calculator: true,
            },
        });
    }
}
